import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import PageTitle from '../../components/Common/PageTitle';
import CustomFeatureModal from '../../modals/CustomFeatureModal';
import DeleteCustomFeatureModal from '../../modals/DeleteCustomFeatureModal';
import { submissionError } from '../../actions/formActions';
import {
  getCustomFeatures,
  addCustomFeature,
  updateCustomFeature,
} from '../../actions/teamActions';
import { camelCaseToUnderscoreCase } from '../../utils/stringUtils';

class HomeContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customFeatureModalOpen: false,
      deleteCustomFeatureModalOpen: false,
    };
  }

  componentDidMount() {
    const { doGetCustomFeatures } = this.props;
    doGetCustomFeatures();
  }

  toggleCustomFeatureModal = (title = 'Add Content') => {
    const { customFeatureModalOpen } = this.state;
    this.setState({
      customFeatureModalOpen: !customFeatureModalOpen,
      customFeatureModalTitle: title,
    });
  };

  toggleDeleteCustomFeatureModal = () => {
    const { deleteCustomFeatureModalOpen } = this.state;
    this.setState({
      deleteCustomFeatureModalOpen: !deleteCustomFeatureModalOpen,
    });
  };

  render() {
    const {
      customFeatureModalOpen,
      customFeatureModalTitle,
      customFeature,
      deleteCustomFeatureModalOpen,
    } = this.state;
    const {
      customFeatures,
      doUpdateCustomFeature,
      doAddCustomFeature,
    } = this.props;
    let customContent;
    if (customFeatures && customFeatures.length) {
      customContent = customFeatures.filter((f) => f.content.type === 'homeFeatureCard');
    }
    return (
      <ContentWrapper>
        <Row>
          <Col xs={12}>
            <PageTitle title="Home Screen Content" />
          </Col>
        </Row>
        <div className="main-content-container">
          <Row>
            <Col className="mt-3">
              <Button
                color="primary"
                onClick={() => {
                  this.setState(
                    {
                      customFeature: undefined,
                    },
                    () => {
                      this.toggleCustomFeatureModal();
                    }
                  );
                }}
              >
                <div className="d-flex flex-row align-items-center">
                  <em className="font-size-one-point-two-five icon-folder-alt mr-2" />
                  <div>Add Content</div>
                </div>
              </Button>
            </Col>
          </Row>
          {customContent !== undefined ? (
            <>
              {customContent.length === 0 ? (
                <Row className="mb-2">
                  <Col>You don't have any custom content entered.</Col>
                </Row>
              ) : (
                <>
                  <Row className="mb-2 mt-4">
                    <Col className="d-flex align-items-end text-bold" xs={1} md={1}>
                      Icon
                    </Col>
                    <Col xs={3} md={3} className="text-bold">
                      Title
                    </Col>
                    <Col xs={5} md={6} className="text-bold">
                      Content
                    </Col>
                    <Col xs={2} md={2} className="text-bold text-center">
                      Actions
                    </Col>
                  </Row>
                  {customContent.map((l) => (
                    <Row key={l.id}>
                      <Col xs={1} className="d-flex flex-row leaderboard-row">
                        <img
                          src={`/img/icons/${camelCaseToUnderscoreCase(l.content.icon).toLowerCase()}.svg`}
                          className="custom-link-icon"
                        />
                      </Col>
                      <Col xs={3} md={3} className="leaderboard-row">
                        {l.content.link !== undefined && l.content.link.length > 0 ? (
                          <a href={l.content.link} target="_blank" rel="noreferrer">
                            {l.content.title}
                          </a>
                        ) : (
                          <>{l.content.title}</>
                        )}
                      </Col>
                      <Col xs={5} md={6} className="leaderboard-row">
                        {l.content.description}
                      </Col>
                      <Col xs={2} md={2} className="leaderboard-row text-center">
                        <span
                          className="span-link"
                          onClick={() => {
                            this.setState(
                              {
                                customFeature: l,
                              },
                              () => {
                                this.toggleCustomFeatureModal('Edit Content');
                              }
                            );
                          }}
                        >
                          Edit
                        </span>
                        <>
                          <span className="hidden-on-mobile"> | </span>
                          <span className="only-on-mobile"> </span>
                          <span
                            className="span-link"
                            title="Delete"
                            onClick={() => {
                              this.setState(
                                {
                                  customFeature: l,
                                },
                                () => {
                                  this.toggleDeleteCustomFeatureModal();
                                }
                              );
                            }}
                          >
                            Delete
                          </span>
                        </>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </>
          ) : null}
        </div>
        <CustomFeatureModal
          isOpen={customFeatureModalOpen}
          toggle={this.toggleCustomFeatureModal}
          title={customFeatureModalTitle}
          customFeature={customFeature}
          type="homeFeatureCard"
          onSubmit={(values) => {
            if (values.id !== undefined && values.id.length > 0) {
              doUpdateCustomFeature(values);
            } else {
              doAddCustomFeature(values);
            }
            this.toggleCustomFeatureModal();
          }}
          icon="icon-folder-alt"
        />
        <DeleteCustomFeatureModal
          isOpen={deleteCustomFeatureModalOpen}
          toggle={this.toggleDeleteCustomFeatureModal}
          customFeature={customFeature}
        />
      </ContentWrapper>
    );
  }
}

HomeContent.propTypes = {
  showSubmissionError: PropTypes.func,
  team: PropTypes.instanceOf(Object),
  doGetCustomFeatures: PropTypes.func,
  customFeatures: PropTypes.instanceOf(Array),
  doUpdateCustomFeature: PropTypes.func,
  doAddCustomFeature: PropTypes.func,
};
const mapStateToProps = (state) => ({
  team: state.team,
  customFeatures: state.team.customFeatures,
  currentUser: state.auth.user,
});
const mapDispatchToProps = (dispatch) => ({
  showSubmissionError: (errors) => dispatch(submissionError(errors)),
  doGetCustomFeatures: () => dispatch(getCustomFeatures()),
  doUpdateCustomFeature: (params) => dispatch(updateCustomFeature(params)),
  doAddCustomFeature: (params) =>
    dispatch(
      addCustomFeature({
        ...params,
        type: 'homeFeatureCard',
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeContent);
